import React, { useEffect, useState } from "react";

import { fireOnce } from "@ds-developer/frontend";

import { useAuth } from "@hubcapp/context";
import { useTealium } from "@hubcapp/context";

import { UpdateHourlyRateModalStateProviderProps } from "./types";

import UpdateHourlyRateModal from "./UpdateHourlyRateModal";
import useGetPricesForAllocationAndLocation from "./hooks/useGetPricesForAllocationAndLocation";
import useMutationUpdateHourlyRate from "./hooks/useMutationUpdateHourlyRate";

const StateProvider: React.FC<UpdateHourlyRateModalStateProviderProps> = ({
  open = false,
  handleClose,
  fullName,
  allocation,
  postcode,
}) => {
  const {
    instructor: { id: instructorId },
  } = useAuth();

  const [propositionAllocationId, setPropositionAllocationId] = useState<
    string
  >("");

  useEffect(() => {
    if (allocation) {
      setPropositionAllocationId(allocation?.propositionAllocationKey || "");
    }
  }, [allocation]);

  const onCompleted = () => handleClose();
  const { trackEvent } = useTealium();

  const [updateHourlyRate, { loading }] = useMutationUpdateHourlyRate({
    onCompleted,
  });

  const { data } = useGetPricesForAllocationAndLocation({
    instructorId,
    propositionAllocationId: propositionAllocationId || "",
    postcode,
  });

  if (!allocation) return null;

  const productCategoryType = allocation?.productCategory;

  const maximumRate = data?.instructor.prices.find(
    price => price.productCategory === productCategoryType,
  )?.price;

  if (!open || !maximumRate) return null;

  const handleSubmit = (rate: number) => {
    trackEvent({
      eventCategory: "View Learner - Edit Hourly Rate",
      eventAction: "Button Click",
      eventLabel: "Save",
    });
    updateHourlyRate({
      variables: {
        allocationId: allocation.id,
        rate,
      },
    });
  };

  const handleClickHourlyRate = () => {
    fireOnce(
      "View Learner - Edit Hourly Rate|Interaction|New Hourly Rate",
      () => {
        trackEvent({
          eventCategory: "View Learner - Edit Hourly Rate",
          eventAction: "Interaction",
          eventLabel: "New Hourly Rate",
        });
      },
    );
  };

  const handleClickCancel = () => {
    trackEvent({
      eventCategory: "View Learner - Edit Hourly Rate",
      eventAction: "Button Click",
      eventLabel: "Cancel",
    });
    handleClose();
  };

  return (
    <UpdateHourlyRateModal
      fullName={fullName}
      maximumRate={maximumRate}
      currentRate={
        (allocation.purchaseRate || 0) *
          ((allocation.purchaseVatRate || 0) + 1) || 0
      }
      onCancel={handleClickCancel}
      loading={loading}
      onSubmit={handleSubmit}
      handleClickHourlyRate={handleClickHourlyRate}
    />
  );
};
export default StateProvider;
